import {Component, EventEmitter, Input, Output, ViewEncapsulation} from "@angular/core";
import {BaseComponent} from "../../../../common/components/base.component";
import {PlaceType} from "../../place.category/customize.place.category.component";
import {HubPlace} from "../../../../models/hub/hub.place";
import {PlaceService} from "../../../../services/place.service";
import {MatCheckboxChange} from "@angular/material/checkbox";

@Component({
    selector: 'ig-place-category-selector',
    templateUrl: './place.category.selector.component.html',
    styleUrls: ['./place.category.selector.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PlaceCategorySelectorComponent extends BaseComponent {

    public hubName: string;
    public isUseDefault = true;
    public mergedDefaultCategories: { keys: string[], values: string[] }[];
    public clientPlaceCategories: PlaceType[] = [];

    @Input() public blockGooglePlaceCategories: string[] = [];
    @Input() public item: PlaceType = new PlaceType();
    @Input() public place: HubPlace;

    constructor() {
        super();
    }

    public isCreateNewPlace() {
        return !this.place || !this.place.categoryText;
    }

    public isSelected(categoryTitle: string) {
        if (this.isCreateNewPlace()) return false;

        return this.place.categoryList.indexOf(categoryTitle) >= 0;
    }

    public selectionChange(category: MatCheckboxChange) {
        let categoryTitle = category.source.name;

        categoryTitle = PlaceService.toCategoryCode(categoryTitle);
        if (this.place.categoryList.indexOf(categoryTitle) >= 0) {
            this.place.categoryList = this.place.categoryList.filter(x => x !== categoryTitle);
        } else {
            this.place.categoryList.push(categoryTitle);
        }
        this.place.category = this.place.categoryList.join(', ');
        const readable = this.place.categoryList.map(x => PlaceService.toReadableCategory(x));
        this.place.categoryText = readable.join(', ');
    }

    public toReadable(code: string) {
        return PlaceService.toReadableCategory(code);
    }

    public toCode(category: string) {
        return PlaceService.toCategoryCode(category);
    }

}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.place.category.modal/place.category.selector/place.category.selector.component.ts